<div class="card mt-4">
  <div class="card-header card-header-primary">
    <h4 class="card-title">Audit History</h4>
    <p class="card-category">Recent sitemap audit runs</p>
  </div>
  <div class="card-body">
    <ul class="list-group list-group-flush">
      <li *ngFor="let item of history"
          class="list-group-item d-flex justify-content-between align-items-center cursor-pointer hover-bg"
          (click)="selectAudit(item)">
        <div>
          <strong>{{ item.createdAt | date:'short' }}</strong>
          <div class="small text-muted">{{ item.sitemapUrl | slice:0:30 }}...</div>
        </div>
        <div class="text-right">
          <span class="badge" [ngClass]="item.sitemapStatus === 200 ? 'badge-success' : 'badge-danger'">
            {{ item.sitemapStatus }}
          </span>
          <div class="small text-muted">{{ item.totalUrlsInSitemap }} URLs</div>
        </div>
      </li>
    </ul>
  </div>
</div>

<style>
  .cursor-pointer { cursor: pointer; }
  .hover-bg:hover { background-color: #f8f9fa; }
</style>
